<template>
  <div>
    <nav-bar :title="titlePage"></nav-bar>
    <div class="atm-desktop-max-width py-4 mobile">
      <b-skeleton-wrapper :loading="loading">
        <template #loading>
          <checklist-skeleton />
        </template>
        <b-row v-if="childPlans.length > 1">
          <b-card no-body class="border-0 w-100" id="modules">
            <b-tabs small card>
              <b-tab
                v-for="(module, idx) in childPlans"
                :key="idx"
                :title="module.Module"
                :disabled="!module.unlocked"
                :active="moduleOrder == module.Order"
              >
                <plan-tab
                  :module="module"
                  :parentName="parentName"
                  :childName="childName"
                ></plan-tab>
              </b-tab>
            </b-tabs>
          </b-card>
        </b-row>
        <span v-else-if="childPlans.length === 1">
          <plan-tab
            :module="childPlans[0]"
            :parentName="parentName"
            :childName="childName"
          ></plan-tab>
        </span>
      </b-skeleton-wrapper>
    </div>
  </div>
</template>

<script>
import { useSessionStore } from '@/common';
import { NavBar } from '@/common/components';
import { getChildPlans } from '../services';
import ChecklistSkeleton from '../components/skeleton/ChecklistSkeleton.vue';
import PlanTab from '../components/PlanTab';

export default {
  data() {
    const sessionStore = useSessionStore();
    return {
      sessionStore,
      childPlans: [],
      loading: false,
    };
  },
  components: {
    NavBar,
    PlanTab,
    ChecklistSkeleton,
  },
  computed: {
    moduleOrder() {
      return this.$route.params.moduleOrder;
    },
    parentName() {
      if (this.userIsAParent) {
        return 'You';
      } else {
        return this.sessionStore.parentName;
      }
    },
    childName() {
      if (this.userIsAParent) return this.sessionStore.childName;
      return 'I';
    },
    userIsAParent() {
      return this.sessionStore.userIsAParent;
    },
    titlePage() {
      return this.userIsAParent ? `${this.childName}'s Plans` : 'My Plan';
    },
  },
  async mounted() {
    this.loading = true;
    let childId = this.userIsAParent ? this.sessionStore.childSelectedId : this.sessionStore.userId;
    try {
      this.childPlans = await getChildPlans({ childId: childId });
    } catch (error) {
      console.error(error);
    } finally {
      this.loading = false;
    }
  },
};
</script>

<style lang="scss">
.nav-tabs .nav-item {
  font-size: 1rem;
  font-weight: 500;
  min-width: fit-content;
  padding: 10px;
  border-radius: 8px 8px 0 0;

  &:hover {
    background-color: #f2f2f2;
  }
}

.nav-tabs .nav-link:focus,
.nav-tabs .nav-link {
  &:hover {
    background-color: transparent;
    border-color: transparent;
  }
}
.card-header {
  padding: 0;
  background-color: transparent;
  border: none;
}
.card-header-tabs {
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  width: 100%;
}
.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
  color: black;
  height: 100%;
  border: none;
  border-bottom: 4px solid var(--color-main) !important;
  margin: 0 !important;
}
</style>
